import React from 'react';
import './styles.scss';
import { Spinner, Table } from 'react-bootstrap';
import partnerByIdRes from '../../../../components/api/partner/getByIdRes.json';
import Modal from '../../../../components/organisms/modals';
import { Delete, Pencil } from '../../../../components/atoms/icons';
import { successUpdateMsg } from '../../../../components/atoms/const';

interface Props {
    isLoading: boolean;
    contactPerson: typeof partnerByIdRes.data.contactPerson | undefined;
    modal: {
        result: any;
        isLoading: boolean;
        // eslint-disable-next-line no-unused-vars
        handleDelete: (contactId: number) => void;
        onAfterDelete: () => void;
    }
    // eslint-disable-next-line no-unused-vars
    onNavigateToEdit: (contactId: number) => void;
    widthHandler: {
        minWidth: string,
        width: string,
        maxWidth: string
    }
}

function RenderTableContactPerson(props: Props) {
  const {
    isLoading, contactPerson, modal, onNavigateToEdit, widthHandler,
  } = props;
  const thLabel = React.useMemo(() => ['NAME', 'EMAIL ADDRESS', 'PHONE NUMBER', 'POSITION', 'ACTIONS'], []);

  const renderModalBody: string = React.useMemo(() => {
    if (!modal.result) return 'Are you sure? Do you want to delete this Contact Person';
    return successUpdateMsg.SUCCESS_DELETE_CLIENT_CONTACT_MSG;
  }, [modal.result]);

  return (
    <div className="table-container mb-4">
      <div className="fz-18 fw-bold my-2" style={{ marginLeft: '30px' }}>Contact Person Detail</div>
      <Table borderless responsive>
        <thead>
          <tr>
            <th style={widthHandler}>&nbsp;</th>
            {thLabel.map((th) => (
              <th className="thead-content" key={th} style={th !== 'ACTIONS' ? { minWidth: '150px' } : { width: '50px' }}>{th}</th>
            ))}
            <th style={widthHandler}>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          {(() => {
            if (isLoading || !contactPerson || contactPerson.length === 0) {
              return (
                <tr>
                  <td colSpan={7}>
                    <div className="w-100 flexible-center my-2 fz-14 align-middle">
                      {isLoading ? <Spinner animation="border" size="sm" /> : <div className="text-center">Data Not Found</div>}
                    </div>
                  </td>
                </tr>
              );
            }
            return (
              contactPerson.map((contact) => (
                <tr key={contact.id} className="align-middle my-2 fz-14">
                  <td style={widthHandler}>&nbsp;</td>
                  <td>
                    <div className="d-flex align-items-center justify-content-start">
                      <div
                        style={{
                          height: 30, width: 30, backgroundColor: '#B1B6CE', paddingTop: '1px', marginTop: '-2px',
                        }}
                        className="rounded-circle flexible-center fz-14 fw-bold text-white me-2"
                      >
                        {contact.firstname?.slice(0, 1).toUpperCase() ?? '-'}
                      </div>
                      <div>{contact.firstname && contact.lastname ? `${contact.firstname} ${contact.lastname}` : '-'}</div>
                    </div>
                  </td>
                  <td>{contact.email ?? '-'}</td>
                  <td>{contact.phoneNumber ?? '-'}</td>
                  <td>{contact.position ?? '-' }</td>
                  <td>
                    <div className="d-flex my-2 justify-content-between align-items-center w-100 px-1">
                      <Modal.Default
                        cancelLabel="No"
                        submitLabel="Yes"
                        title="Delete Contact Person"
                        body={renderModalBody}
                        onSubmit={() => modal.handleDelete(contact.id)}
                        dialogClassName="custom-modal-width"
                        isLoading={modal.isLoading}
                        result={modal.result}
                        onAfterResult={modal.onAfterDelete}
                      >
                        <div style={{ marginBottom: '2px' }}>
                          <Delete width={18} />
                        </div>
                      </Modal.Default>
                      <button
                        type="button"
                        onClick={() => onNavigateToEdit(contact.id)}
                        className="bg-transparent border-0"
                      >
                        <Pencil width={20} />
                      </button>
                    </div>
                  </td>
                  <td style={widthHandler}>&nbsp;</td>
                </tr>
              ))
            );
          })()}
        </tbody>
      </Table>
    </div>
  );
}

export default React.memo(RenderTableContactPerson);
